// extracted by mini-css-extract-plugin
export default {"product-box":"ProductCard_product-box__QltJt","product-title":"ProductCard_product-title__KrwYr","price":"ProductCard_price__IEwqs"};